import anniversaryImage from '../components/assets/events/42nd-anniversary.jpg';
import mynameImage from '../components/assets/events/myname.png';
import manianImage from '../components/assets/events/manian.jpeg';
import halloweenImage from '../components/assets/events/halloween.jpg';
import recitationImage from '../components/assets/events/recitation-2026.jpg';
import belfastZooImage from '../components/assets/events/belfast-zoo.jpg';

export const homePageCards = [
  {
    imageSrc: belfastZooImage,
    imageAlt: 'CLSNI group outing to Belfast Zoo',
    titleKey: 'event-title-25',
    descriptionKey: 'event-description-25',
    link: 'https://mp.weixin.qq.com/s/TCMVgRPdFgqIfM9OkCzSwg?token=194586250&lang=zh_CN',
  },
  {
    imageSrc: recitationImage,
    imageAlt: 'CLSNI students at the 2026 Mandarin recitation competition',
    titleKey: 'event-title-26',
    descriptionKey: 'event-description-26',
    link: 'https://mp.weixin.qq.com/s/P0R9KQS_XOdor_WU63Tc2A?token=194586250&lang=zh_CN',
  },
  {
    imageSrc: anniversaryImage,
    imageAlt: '42nd anniversary event',
    titleKey: 'event-title-15',
    descriptionKey: 'event-description-15',
    link: 'https://mp.weixin.qq.com/s/UeGc0BigdXQSx26_WsZFMA',
  },
  {
    imageSrc: mynameImage,
    imageAlt: 'My Name event',
    titleKey: 'event-title-19',
    descriptionKey: 'event-description-19',
    link: 'https://mp.weixin.qq.com/s/yADRD6lneMyvGJ-gdVCMaA',
  },
  {
    imageSrc: manianImage,
    imageAlt: 'Manian event',
    titleKey: 'event-title-20',
    descriptionKey: 'event-description-20',
    link: 'https://mp.weixin.qq.com/s/4N2yjFGJpLHzgPCDjWZmYA',
  },
  {
    imageSrc: halloweenImage,
    imageAlt: 'Halloween event',
    titleKey: 'event-title-22',
    descriptionKey: 'event-description-22',
    link: 'https://mp.weixin.qq.com/s/ZgSOejRfyPJvIrrG7h6XWw',
  },
];
